import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group bg-bg-items-white',
    container: 'flex items-center gap-2',
    text: 'text-main'
  },
  variants: {
    disabled: {
      true: {
        text: 'text-inactive'
      }
    }
  }
});
